import { call, put, select } from 'redux-saga/effects';

import * as actions from './labels.actions';

import { ILabelCreate, ILabelCreateForm, ILabel } from '../../../resource/label/label.types';
import * as dialogService from '../../../dialog/dialog.saga-services';
import { labelsPageSelectors } from './labels.selectors';
import * as labelResourceService from '../../../resource/label/label.saga-service';
import { selectWithParams } from '../../../../utils/selector.utils';
import { labelSelectors } from '../../../resource/label/label.selectors';
import { clearLabel } from '../../../resource/label/label.actions';

export function* clearLabels() {
  yield put(actions.clearLabel());
}

export function* setupLabels() {
  const labels = (yield call(labelResourceService.searchLabels)) as ILabel['id'][];

  yield put(labels ? actions.storeLabels(labels) : actions.clearLabel());
}

export function* createLabel(labelInfo: ILabelCreateForm) {
  const label = (yield call(labelResourceService.createLabel, mapLabelFormToLabelCreate(labelInfo))) as ILabel;

  if (!label) {
    return;
  }

  yield call(dialogService.closeDialog, 'labelFormDialog');
}

export function* updateLabel(labelId: ILabel['id'], labelInfo: ILabelCreateForm): Generator {
  const label = (yield call(labelResourceService.updateLabel, {
    id: labelId,
    ...mapLabelFormToLabelCreate(labelInfo),
  })) as ILabel;

  if (!label) {
    return;
  }
  const labelsIds = (yield select(labelsPageSelectors.selectLabels)) as ILabel['id'][];

  yield put(labelsIds ? actions.storeLabels([...labelsIds]) : actions.clearLabel());
  yield call(dialogService.closeDialog, 'labelFormDialog');
}

export function* deleteLabel(labelId: ILabel['id']) {
  const label = (yield selectWithParams(labelSelectors.selectResourceById, labelId)) as ILabel;
  if (!label) {
    return;
  }

  yield call(labelResourceService.deleteLabel, labelId);

  // Remove label from the label resource store
  yield put(clearLabel(labelId));
}

export const mapLabelFormToLabelCreate = (labelInfo: ILabelCreateForm): ILabelCreate => ({
  name: labelInfo.name,
  color: labelInfo.color,
  meetingId: labelInfo.meetingId,
});

export function* clearLabelsPageStorage() {
  yield put(actions.clearLabel());
}
